module.exports = __webpack_public_path__ + "img/39_52.82b9e22a.png";